import http from '@/biz/http.mjs'

export default {
    discard: ({pkid}) => http.put(
        '/prjchgs/rlsandrevise',
        {pkid, stsCode: 'DISCARD'}
    ),

    publish: (data) => http.put(
        '/prjchgs/rlsandrevise',
        {...data, stsCode: 'RLS'}
    ),

    //pull: ({pkid}) => http.get(`/prjchgs/${pkid}/dps`),
    push: (data) => http.post('/prjchgs/batchmodify', data),
    read: ({pkid}) => http.get(`/prjchgs/${pkid}`),

    //revise: ({pkid}) => http.put(
        //'/prjchgs/rlsandrevise',
        //{pkid, stsCode: 'REVISE'}
    //),

    updateMap: (data) => http.put(`/prjchgs/${data.pkid}/map`, data),
}
